<template>
  <e-dialog
    :value="value"
    :title-line="false"
    dense
    max-width="408"
    @close="hide"
  >
    <h3 class="mb-8 mx-15 text-sign-up text-center" v-html="popupTitle" />

    <v-form ref="ruleFormRef" class="px-6" @submit.prevent="submit">
      <label class="text-subtitle-2">Email</label>
      <v-text-field
        v-model="formData.email"
        :rules="[$formRules.required, $formRules.email]"
        dense
        outlined
        placeholder="Enter your email"
        class="mt-1"
      />

      <label class="text-subtitle-2">Password</label>
      <v-hover v-slot="{ hover }">
        <v-text-field
          v-model="formData.password"
          :rules="[$formRules.required, isLoginPopup ? true : $formRules.password]"
          :type="isShowPassword ? 'text' : 'password'"
          dense
          outlined
          placeholder="Enter your password"
          class="mt-1"
        >
          <template #append>
            <v-icon v-show="hover" tabindex="-1" @click="isShowPassword = !isShowPassword">
              {{ isShowPassword ? 'visibility' : 'visibility_off' }}
            </v-icon>
          </template>
        </v-text-field>
      </v-hover>

      <template v-if="!isLoginPopup">
        <label class="text-subtitle-1">Confirm Password</label>
        <v-hover v-slot="{ hover }">
          <v-text-field
            v-model="formData.confirmPassword"
            :rules="[$formRules.required, $formRules.confirmPassword(formData.confirmPassword, formData.password)]"
            :type="isShowConfirmPassword ? 'text' : 'password'"
            dense
            outlined
            placeholder="Confirm your password"
            class="mt-1"
          >
            <template #append>
              <v-icon v-show="hover" tabindex="-1" @click="isShowConfirmPassword = !isShowConfirmPassword">
                {{ isShowConfirmPassword ? 'visibility' : 'visibility_off' }}
              </v-icon>
            </template>
          </v-text-field>
        </v-hover>
      </template>

      <v-btn
        type="submit"
        large
        depressed
        width="100%"
        color="primary"
        class="rounded-lg"
      >
        {{ isLoginPopup ? 'Sign In' : 'Sign Up' }}
      </v-btn>

      <v-layout class="my-7 align-center">
        <v-divider />
        <span class="mx-2 text-subtitle-1 secondary--text">Or</span>
        <v-divider />
      </v-layout>

      <v-layout class="mb-8">
        <v-flex class="mr-2">
          <v-btn
            large
            depressed
            color="#CD5542"
            class="rounded-lg white--text"
            width="100%"
            @click="ggLogin"
          >
            <v-icon size="20" class="mr-2">
              mdi-google
            </v-icon>
            Continue with Google
          </v-btn>
        </v-flex>

        <v-flex class="flex-0-0">
          <v-btn
            large
            depressed
            icon
            class="rounded-lg primary"
          >
            <v-icon size="24" color="white">
              mdi-facebook
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>

    <p v-if="isLoginPopup" class="mb-8 text-center text-subtitle-2">
      Not a member? <a class="primary--text" @click="typeOfPopup = 'signUp'">
        Create an account
      </a>
    </p>
    <p v-else class="mb-8 text-center text-subtitle-2">
      Already member? <a class="primary--text" @click="typeOfPopup = 'login'">
        Sign In
      </a>
    </p>
  </e-dialog>
</template>

<script>
import { popup } from '@/utils/index'

export default {
  name: 'PopupLoginSignUp',

  props: {
    value: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      default: () => 'login',
      validate: v => ['login', 'signUp'].includes(v)
    },
    streamName: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    formData: {},
    typeOfPopup: '',
    isShowPassword: false,
    isShowConfirmPassword: false
  }),

  computed: {
    isLoginPopup() {
      return this.typeOfPopup === 'login'
    },
    popupTitle() {
      if (this.isLoginPopup) {
        return 'Sign in to continue <br> using EOwn'
      }
      if (this.streamName) {
        return `Create an account to edit on <br> “${this.streamName}”`
      }
      return 'Create an account'
    }
  },

  watch: {
    value(v) {
      if (v) {
        this.typeOfPopup = this.type
        this.formData = {}
        this.isShowPassword = false
        this.isShowConfirmPassword = false
      }
    }
  },

  methods: {
    hide() {
      this.$emit('input', false)
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    async ggLogin() {
      try {
        const res = await popup(this.$config.apiUrl + '/auth/google')
        const data = await this.$axios.$get('/auth/google/callback?' + res.query)
        await this.$auth.setUserToken(data.token)
        this.$emit('success')
        this.hide()
      } catch (error) {
        this.$notify.error({
          title: 'Google Login',
          message: this.$helpers.apiErrorMessage(error)
        })
      }
    },
    async submit() {
      const isValid = this.$refs.form.validate()
      if (!isValid) {
        this.$helpers.scrollToFirstError()
        return
      }
      try {
        if (this.isLoginPopup) {
          await this.$auth.loginWith('local', { data: this.formData })
          this.$notify.success({
            title: 'Login',
            message: 'Success!'
          })
          this.$emit('success')
          this.hide()
        } else {
          const resp = await this.$axios.$post('/auth/signup', (({ email, password }) => ({ email, password }))(this.formData))
          if (resp.status === 'success') {
            this.$notify.success({
              title: 'Sign Up',
              message: 'Please check your email'
            })
            this.$helpers.tractMixpanel('subscribe_free', 'new user')
            this.$emit('success')
            this.hide()
          }
        }
      } catch (error) {
        this.$notify.error({
          title: this.isLoginPopup ? 'Login' : 'Sign Up',
          message: this.$helpers.apiErrorMessage(error)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-sign-up {
  font-weight: bold;
  font-size: 19px;
  line-height: 23px;
}
</style>
